export type InPageSurveyQuestionType = 'SINGLE_CHOICE' | 'MULTIPLE_CHOICE'; // 'INPUT'は未対応

const SINGLE_CHOICE = 'SINGLE_CHOICE';
const MULTIPLE_CHOICE = 'MULTIPLE_CHOICE';

export const inPageSurveyQuestionType: {
  SINGLE_CHOICE: InPageSurveyQuestionType;
  MULTIPLE_CHOICE: InPageSurveyQuestionType;
} = {
  SINGLE_CHOICE,
  MULTIPLE_CHOICE,
};
